import { Button, Grid, Typography, debounce } from "@mui/material";

// My Imports
import AddIcon from "@mui/icons-material/Add";
import { gridSpacing } from "../../store/constant";
import MainCard from "../../ui-component/cards/MainCard";
import { useCallback, useState } from "react";

export default function Content({
  field = { name: "Title", value: "name" },
  onSearchFieldSelect = (val) => {},
  searchFields = [],
  searchDebounceTimer = 700,
  onSearchEnd = (val) => {},
  tabs = () => <></>,
  heading = "",
  addHeading = "",
  onClickAdd = () => {},
  children = <></>,
  hasSearch = true,
}) {
  const [search, setSearch] = useState("");
  const [_field, setField] = useState(field);

  const handleSearchDebounce = useCallback(
    debounce((val) => {
      onSearchEnd && onSearchEnd(val);
    }, searchDebounceTimer || 700),
    []
  );

  const handleSearch = (e) => {
    setSearch(e.target.value);
    handleSearchDebounce(e.target.value);
  };

  const handleFieldSelect = (e) => {
    setField(e.target.value);
    onSearchFieldSelect(e.target.value);
  };

  return (
    <MainCard
      title={
        <Grid
          flex={0.5}
          container
          alignItems="center"
          justifyContent="space-between"
          spacing={gridSpacing}
        >
          <Grid item>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h3"
                style={{ minWidth: 200, marginRight: 20 }}
              >
                {heading}
              </Typography>
              {!!addHeading && (
                <Button
                  onClick={onClickAdd}
                  variant="outlined"
                  fullWidth
                  size="small"
                  sx={{ minWidth: 120 }}
                  startIcon={<AddIcon />}
                >
                  {addHeading}
                </Button>
              )}
            </div>
          </Grid>
          <Grid flex={0.7} item>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {searchFields.length > 0 && (
                <select
                  value={_field.value}
                  onChange={handleFieldSelect}
                  disabled={searchFields.length === 1}
                  style={{ width: 200 }}
                  className="search-input"
                >
                  {searchFields.map(({ value, name }, i) => (
                    <option key={i} value={value}>
                      {name}
                    </option>
                  ))}
                </select>
              )}

              {hasSearch && (
                <input
                  value={search}
                  onChange={handleSearch}
                  placeholder="Enter keyword ..."
                  className="search-input"
                  style={{ marginLeft: 10 }}
                  type="text"
                />
              )}
            </div>
          </Grid>
        </Grid>
      }
      content={false}
    >
      {tabs()}
      {children}
    </MainCard>
  );
}
